import { COMPLEX_SERVICES_STAGE_ORDER } from '../api/complexServicesFunctions';

/**
 * Complex Services ends with the Contract Record (Step 17 / stage 609), but
 * completion must leave that view and its stepper available for review.
 */
export const COMPLEX_SERVICES_COMPLETION_MESSAGE =
  'Complex Services workflow complete. The contract record and tracker hand-off are saved.';

export const completeComplexServicesRecord = (maxStageReached: number) => {
  const recordStage = COMPLEX_SERVICES_STAGE_ORDER.indexOf('record');

  return {
    currentStage: recordStage,
    maxStageReached: Math.max(maxStageReached, recordStage),
    isComplete: false,
    notification: {
      message: COMPLEX_SERVICES_COMPLETION_MESSAGE,
      type: 'success' as const,
    },
  };
};
